<template>
  <div class="product-row">
    <div
      class="header-row clickable"
      @click="toggleExpand"
    >
      <div>
        {{ product.productName }}
      </div>

      <div class="header-counts">
        <div class="product-number">
          <div class="product-number-label">
            do wydania
          </div>
          <div class="product-number-value">
            {{ product.count - product.delivered }}
          </div>
        </div>
        <div class="product-number">
          <div class="product-number-label">
            zamówione
          </div>
          <div class="product-number-value">
            {{ product.count }}
          </div>
        </div>
        <div>
          <div class="product-number product-number-past d-flex justify-content-end align-items-center">
            <span class="product-number-label pr-2">
              wczoraj
            </span>
            {{ product.previousDayCount }}
          </div>
          <div class="product-number product-number-past mt-1 d-flex justify-content-end align-items-center dimmed">
            <span class="product-number-label pr-2 dimmed">
              zeszły tydzień
            </span>
            {{ product.lastWeekCount }}
          </div>
        </div>
        <div class="chevron-icon">
          <i :class="isExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </div>
      </div>
    </div>
    <div v-if="isExpanded">
      <hr class="divider">
      <div
        v-for="subProduct in filteredSubProducts"
        :key="subProduct.entryDietId"
        class="subdiet-section"
      >
        <div class="subdiet-container">
          <div class="subdiet-header">
            <span
              class="subdiet-name"
              :style="{
                backgroundColor: diets.find((d) => d.nodeId === subProduct.entryDietId)?.color,
                color: diets.find((d) => d.nodeId === subProduct.entryDietId)?.textColor,
                borderColor: diets.find((d) => d.nodeId === subProduct.entryDietId)?.textColor,
              }"
            >{{ subProduct.dietName }}</span>
            <div class="d-flex align-items-center">
              <div class="product-number-subdiet">
                {{ subProduct.count - subProduct.delivered }}
              </div>
              <div class="product-number-subdiet">
                {{ subProduct.count }}
              </div>
              <div>
                <div class="product-number-subdiet d-flex justify-content-end align-items-center">
                  <span class="description pr-2">
                    wczoraj
                  </span>
                  <div>
                    {{ subProduct.previousDayCount }}
                  </div>
                </div>
                <div class="product-number-subdiet mt-1 dimmed d-flex justify-content-end align-items-center">
                  <span class="description pr-2">
                    zeszły tydzień
                  </span>
                  <div>
                    {{ subProduct.lastWeekCount }}
                  </div>
                </div>
              </div>
              <div class="chevron-icon">
&nbsp;
              </div>
            </div>
          </div>
          <div
            v-for="(ingredient, ingIndex) in Object.values(subProduct.ingredients)"
            :key="`${ingredient.id}-${ingredient.dietId}-${ingredient.mealSizeId}`"
            class="ingredient-row"
            :class="{ 'ingredient-row-alt': ingIndex % 2 !== 0 }"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ ingredient.details?.name }}
              </div>
              <div class="d-flex align-items-center">
                <!-- Pozostało do wydania -->
                <div class="product-number">
                  <div class="d-flex flex-column">
                    <div v-if="ingredient.details?.weightUnit">
                      {{
                        convertWeight(ingredient.weight - ingredient.deliveredWeight, ingredient.details?.weightUnit)
                      }}
                      {{ convertWeightUnit(ingredient.details?.weightUnit) }}
                    </div>
                    <div
                      v-if="ingredient.details?.countUnit"
                      class="text-nowrap dimmed"
                    >
                      <span v-if="ingredient.details?.weightUnit" />{{
                        convertWeight(ingredient.count - ingredient.deliveredCount, ingredient.details?.countUnit) }}
                      {{ convertWeightUnit(ingredient.details?.countUnit)
                      }}<span v-if="ingredient.details?.weightUnit" />
                    </div>
                  </div>
                </div>

                <!-- Zamówione -->
                <div class="product-number">
                  <div>
                    <div v-if="ingredient.details?.weightUnit">
                      {{ convertWeight(ingredient.weight, ingredient.details?.weightUnit) }}
                      {{ convertWeightUnit(ingredient.details?.weightUnit) }}
                    </div>
                    <div
                      v-if="ingredient.details?.countUnit"
                      class="text-nowrap dimmed"
                    >
                      <span v-if="ingredient.details?.weightUnit" />
                      {{ convertWeight(ingredient.count, ingredient.details?.countUnit) }}
                      {{ convertWeightUnit(ingredient.details?.countUnit) }}
                      <span v-if="ingredient.details?.weightUnit" />
                    </div>
                  </div>
                </div>

                <div class="product-number">
&nbsp;
                </div>
                <div class="chevron-icon">
&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertWeight, convertWeightUnit } from './utils/unitConversion';

export default {
  props: {
    product: Object,
    expandAll: {
      type: Boolean,
      default: null,
    },
    diets: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    filteredSubProducts() {
      if (!this.product?.subProducts) return [];

      // Check if any subProduct has groups
      const anyGroupsExist = this.product.subProducts.some(
        (sp) => sp.countsByGroup && Object.keys(sp.countsByGroup).length > 0,
      );

      // If groups exist, only show subProducts that have groups
      if (anyGroupsExist) {
        return this.product.subProducts.filter((sp) => sp.countsByGroup && Object.keys(sp.countsByGroup).length > 0);
      }

      // Otherwise show all subProducts
      return this.product.subProducts;
    },
    lastWeekdayLabel() {
      const weekday = new Intl.DateTimeFormat('pl-PL', { weekday: 'long' }).format(new Date());
      return `Zeszły(a) ${weekday}`;
    },
  },
  watch: {
    expandAll(newVal) {
      if (newVal !== null) {
        this.isExpanded = newVal;
      }
    },
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    convertWeight,
    convertWeightUnit,
  },
};
</script>

<style lang="scss" scoped>
  .product-number {
    width: 200px;
    text-align: right;
    font-weight: 600;
  }

  .dimmed {
    color: #666 !important;
    font-weight: 500;
  }

  .product-number-label {
    font-size: 14px;
    line-height: 120%;
    color: #333;
    text-align: right;
    font-weight: 400;

    &.dimmed {
      font-size: 12px;
    }
  }

  .product-number-value {
    font-size: 24px;
    line-height: 100%;
    color: #333;
    text-align: right;
    font-weight: 500;
  }

  .product-number-past {
    font-size: 20px;
    line-height: 100%;
    color: #333;
    text-align: right;

    &.dimmed {
      font-size: 17px;
    }
  }

  .product-number-subdiet {
    width: 200px;
    font-size: 20px;
    line-height: 100%;
    color: #333;
    text-align: right;

    &.dimmed {
      font-size: 17px;
    }

    .description {
      font-size: 12px;
      line-height: 100%;
      color: #333;
      text-align: right;
      font-weight: 400;

      &.dimmed {
        font-size: 12px;
      }
    }
  }

  .ingredient-row {
    font-size: 20px;
    font-weight: 400;
    background-color: #FFFFFF;
    padding: 5px 0 5px 20px;
    border-radius: 5px;
  }

  .ingredient-row-alt {
    background-color: #E8EFFF;
  }

  .product-row {
    background-color: #FFFFFF;
    font-size: 28px;
    font-weight: 600;
    border-radius: 6px;
    padding: 15px;
    margin: 10px 0;
  }

  .clickable {
    cursor: pointer;
  }

  .chevron-icon {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #666;
    margin-left: 16px;
  }

  .subdiet-container {
    background-color: #F5F8FF;
    padding: 10px;
    margin-right: -10px;
    margin-bottom: 10px;
    border-radius: 5px;
  }

  .subdiet-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    padding-bottom: 15px;
  }

  .subdiet-name {
    font-size: 18px;
    padding: 4px 12px;
    border-radius: 4px;
    border: 2px solid;
    display: inline-block;
    text-transform: uppercase;
  }
  .header-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .header-counts {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .divider {
    margin-top: 20px;
    margin-bottom: 15px;
  }
</style>
